import "./Videos-style.css";
function Videos() {
  let array = [
    {
      title: "Object and lane detection",
      url: "https://drive.google.com/file/d/1DkfvimYcn3iuXCplFIYs9MsOadJqI53j/preview",
    },
    {
      title: "Wireless detection",
      url: "https://drive.google.com/file/d/1cPby7zNGBwCwy6unfQbxFQI_hxPPC8NM/preview",
    },
    {
      title: "Wireless detection",
      url: "https://drive.google.com/file/d/1cPby7zNGBwCwy6unfQbxFQI_hxPPC8NM/preview",
    },
    {
      title: "Wireless detection",
      url: "https://drive.google.com/file/d/1cPby7zNGBwCwy6unfQbxFQI_hxPPC8NM/preview",
    },
    {
      title: "Wireless detection",
      url: "https://drive.google.com/file/d/1cPby7zNGBwCwy6unfQbxFQI_hxPPC8NM/preview",
    },
    {
      title: "Wireless detection",
      url: "https://drive.google.com/file/d/1cPby7zNGBwCwy6unfQbxFQI_hxPPC8NM/preview",
    },
    {
      title: "Wireless detection",
      url: "https://drive.google.com/file/d/1cPby7zNGBwCwy6unfQbxFQI_hxPPC8NM/preview",
    },
    {
      title: "Wireless detection",
      url: "https://drive.google.com/file/d/1cPby7zNGBwCwy6unfQbxFQI_hxPPC8NM/preview",
    },
  ];
  return (
    <div className="page">
      <div className="allVideos">
        {array.map((el) => {
          return (
            <div className="VIDEO_CARD">
              <p>
                <b>{el.title} </b>
              </p>
              <iframe
                title="video"
                src={el.url}
                width="100%"
                height="150px"
                allow="fullscreen"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Videos;
